const data = {
  // 'parcel-protection': 'PB Parcel Protection',
  'shipsurance': 'Shipsurance',
};

export default {
  getSelectOptions() {
    let options = Object.keys(data).map((code) => {
      return {
        text: data[code],
        value: code,
      }
    })
    .sort((a, b) => {
      const textA = a.text.toUpperCase();
      const textB = b.text.toUpperCase();

      if (textA < textB) {
        return -1;
      }
      if (textA > textB) {
        return 1;
      }
      return 0;
    })
    ;

    return options;
  },
  getName(code) {
    return data.hasOwnProperty(code) ? data[code] : null;
  },
};


// WEBPACK FOOTER //
// ./resources/assets/js/data/insurance.js